import suppliersApi from "../../services/api/SuppliersApi";

export default {
  async getSupplier({ commit }, id) {
    commit("RESET_SUPPLIER");
    let err, response;
    try {
      [err, response] = await suppliersApi.getSupplier(id);
      if (!err) {
        commit("SET_SUPPLIER", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  }
};
